export class HowToUseTabContentTrigger extends window.BAO.CustomElement() {
  connectedCallback () {
    this.activeTabChecker()
    this.addEventListener('click', (event) => this.onTabClick(event))
  }

  onTabClick (event) {
    const clickedButton = event.target

    const tabSection = clickedButton.closest('.sec-TabContentTabs')
    const tabSectionDescriptionParent = clickedButton.closest('.sec-TabContent_BodyMainInner')
    const contentSection = tabSection.nextElementSibling

    if (tabSection && contentSection) {
      this.activateTab(clickedButton, tabSection, tabSectionDescriptionParent, contentSection)
    }
  }

  activateTab (clickedButton, tabSection, tabSectionDescriptionParent, contentSection) {
    // Deactivate all triggers in the current tab section
    const triggers = tabSection.querySelectorAll('how-to-use-tab-content-trigger')
    triggers.forEach(trigger => trigger.classList.remove('is-active'))

    // Activate the clicked trigger
    clickedButton.classList.add('is-active')

    // Get the identifier of the tab to activate
    const identifier = clickedButton.getAttribute('data-tab-content-trigger')

    // Deactivate all content sections first
    const contents = contentSection.querySelectorAll('tab-content')
    contents.forEach(content => content.classList.remove('is-active'))

    // Activate the content section that matches the identifier
    const targetContent = Array.from(contents).find(content => content.getAttribute('data-tab-content-block') === identifier)
    if (targetContent) {
      targetContent.classList.add('is-active')
    }

    this.scrollTabContentIntoView(identifier)

    // // Deactivate all content sections first
    // const contentsDescription = tabSectionDescriptionParent.querySelectorAll('.sec-TabContent_Content')
    // contentsDescription.forEach(contentsDescriptionItem => contentsDescriptionItem.classList.remove('is-active'))

    // // Activate the content section that matches the identifier
    // const targetContentsDescription = Array.from(contentsDescription).find(contentsDescriptionItem => contentsDescriptionItem.getAttribute('data-tab-content-routine-description') === identifier)
    // if (targetContentsDescription) {
    //   targetContentsDescription.classList.add('is-active')
    // }
  }

  scrollTabContentIntoView (identifier) {
    const contentBlock = document.querySelector(`[data-tab-content-block="${identifier}"]`)

    if (!contentBlock) return

    contentBlock.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }

  activeTabChecker () {
      const tabSections = document.querySelectorAll('.sec-TabContent_HowToUse')

      for(let i = 0; i < tabSections.length; i++) {
        const tabTriggers = tabSections[i].querySelectorAll('.sec-TabContent_HowToUse .sec-TabContentTabs_Trigger')
        const tabContents = tabSections[i].querySelectorAll('.sec-TabContent_HowToUse .sec-TabContent_Body')

        // Function to remove 'is-active' from all tabs and contents
        function removeAllActiveClasses () {
          tabTriggers.forEach(trigger => trigger.classList.remove('is-active'))
          tabContents.forEach(content => content.classList.remove('is-active'))
        }

        // Function to set a tab and its content as active
        function setActiveTab (index) {
          if (tabTriggers[index]) {
            tabTriggers[index].classList.add('is-active')
          }
          if (tabContents[index]) {
            tabContents[index].classList.add('is-active')
          }
        }

        // Find the first tab with content and set it as active
        let hasActive = false
        for (let i = 0; i < tabContents.length; i++) {
          if (!tabContents[i].querySelector('.sec-TabContent_Content')) return

          if (tabContents[i].querySelector('.sec-TabContent_Content').innerText.trim() !== '') {
            removeAllActiveClasses()
            setActiveTab(i)
            hasActive = true
            break
          }
        }

        // Fallback in case no tab qualifies, to ensure functionality
        if (!hasActive && tabContents.length > 0) {
          setActiveTab(0) // Default to the first tab as active if all are empty
        }
      }
  }
}

if (!customElements.get('how-to-use-tab-content-trigger')) {
  customElements.define('how-to-use-tab-content-trigger', HowToUseTabContentTrigger)
}
